module.exports = __webpack_public_path__ + "img/background_medio_pc.6c6973cc.webp";